// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","background":"App_background__IxVd3","backgroundImg":"App_backgroundImg__p0zVK","animScale":"App_animScale__Twenc"};